import { createFileRoute } from "@tanstack/react-router"
import { KanbanBoard } from "~/components/MediaSpace/KanbanBoard"

function BoardPage() {
  const { boardId } = Route.useParams()
  return <KanbanBoard boardId={boardId} />
}

export const Route = createFileRoute("/media-space/board/$boardId")({
  component: BoardPage,
})
